module.exports = __webpack_public_path__ + "static/img/cp2.a96c3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cp2.png
// module id = 25GE
// module chunks = 1